// import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

// // ElementUI
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import '@/style/elementTheme/theme/index.css'
// import '@/style/control/common.scss'
// // 必须要写在 ElementUI css 样式后面 这样icon的样式才能起作用，不然会把icon的样式覆盖掉
// import './assets/iconfonts/iconfont.css'
// Vue.use(ElementUI)

// vuescroll 滚动条插件
import vuescroll from 'vuescroll'
import 'qweather-icons/font/qweather-icons.css'
// 你可以在这里设置全局配置
Vue.use(vuescroll, {
  // ops: {}, // 在这里设置全局默认配置
  // name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
})

// 解决莫名警告问题
import 'default-passive-events'
// 翻译过来如下：违反：没有添加被动事件监听器来阻止'touchstart'事件，请考虑添加事件管理者'passive'，以使页面更加流畅。
// 原因是 Chrome51 版本以后，Chrome 增加了新的事件捕获机制－Passive Event Listeners；

// Passive Event Listeners：就是告诉前页面内的事件监听器内部是否会调用preventDefault函数来阻止事件的默认行为，
// 以便浏览器根据这个信息更好地做出决策来优化页面性能。
// 当属性passive的值为true的时候，代表该监听器内部不会调用preventDefault函数来阻止默认滑动行为，
// Chrome浏览器称这类型的监听器为被动（passive）监听器。
// 目前Chrome主要利用该特性来优化页面的滑动性能，所以Passive Event Listeners特性当前仅支持mousewheel/touch相关事件。

// 引入全局类
import utils from '@/utils/utils.js' // 公共工具
import api from '@/api/index.js' // api 请求接口
import toaster from '@/utils/toaster' // 提示信息
import globalValue from '@/utils/globalValue' // 全局变量
import rsa from '@/utils/rsa' // RSA封装方法
import aes from '@/utils/aes' // AES封装方法

// 绑定在原型上
Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.prototype.$toaster = toaster
Vue.prototype.$globalValue = globalValue
Vue.prototype.$project = 'bby'
Vue.prototype.$filters = filters
Vue.prototype.$rsa = rsa
Vue.prototype.$aes = aes

//引入filter 过滤器
import * as filters from '@/utils/filters.js'
// import 'babel-polyfill' //兼容IE11
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// import videojs from 'video.js'
// import 'video.js/dist/video-js.css'
// import 'videojs-contrib-hls'
// Vue.use(videojs)
// 引入echarts
// import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import EZUIKit from 'ezuikit-js'
Vue.use(EZUIKit)

// 引入serverUrl   ---  请求接口
import serverUrl from '@/utils/server'
Vue.prototype.$serverUrl = serverUrl.apiurl

// 路由重定向 --- 路由权限控制
import '@/permission/permission.js' // permission control

Vue.config.productionTip = false
Vue.directive('allowy', {
  bind: function (el, binding) {
    let permissionList = binding.value //在页面上绑定的 对应权限显示
    let roles = window.localStorage.getItem('arr') //获取的用户权限
    roles = JSON.parse(roles)
    el.style.display = 'none'
    for (let i = 0; i < roles.length; i++) {
      if (permissionList == roles[i]) {
        el.style.display = 'inline-block'
        break
      }
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
